<script>
import Vertical from "./vertical";
import Horizontal from "./horizontal";

import { layoutComputed, authComputed } from "@/state/helpers";

/**
 * Main layout
 */
export default {
  computed: {
    ...layoutComputed,
    ...authComputed,
    isMode: layoutComputed.layoutMode,
    
  },
  components: { Vertical, Horizontal },
  mounted() {
    if (layoutComputed.layoutMode == "dark") {
      {
        document.body.setAttribute("data-layout-mode", "dark");
        document.body.setAttribute("data-topbar", "dark");
      }
    }
  },
};
</script>

<template>
  <div>
    <Vertical v-if="loggedIn" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal v-if="!loggedIn" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>

